/* Shared carousel behaviour for the B2B landing page.
   Scrolling itself is native (CSS scroll-snap); this drives the arrows and the
   windowed dot indicator, and keeps offscreen videos paused. */
(function () {
  'use strict';

  function initCarousel(root) {
    if (root.dataset.b2bCarouselReady === 'true') return;
    root.dataset.b2bCarouselReady = 'true';

    var viewport = root.querySelector('[data-carousel-viewport]');
    var track = root.querySelector('[data-carousel-track]');
    var dotsWrap = root.querySelector('[data-carousel-dots]');
    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');

    if (!viewport || !track) return;

    var items = track.children;
    if (!items.length) return;

    var pageCount = 1;

    /* One card plus the track's column gap. */
    function cardStep() {
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return items[0].getBoundingClientRect().width + gap;
    }

    function maxScroll() {
      return viewport.scrollWidth - viewport.clientWidth;
    }

    /* A "page" is one viewport-width of cards; the last one is usually
       partial, so round up. */
    function measure() {
      var max = maxScroll();
      pageCount = max <= 1 ? 1 : Math.ceil(max / viewport.clientWidth) + 1;
      /* Everything fits — centre the cards and drop the controls entirely
         rather than leaving dead arrows behind. */
      root.classList.toggle('frido-b2b-carousel--static', max <= 1);
      buildDots();
      update();
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.textContent = '';
      if (pageCount < 2) return;

      for (var i = 0; i < pageCount; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'frido-b2b-dot';
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.dataset.index = String(i);
        dotsWrap.appendChild(dot);
      }
    }

    function currentPage() {
      var max = maxScroll();
      if (max <= 1) return 0;
      return Math.round((viewport.scrollLeft / max) * (pageCount - 1));
    }

    function update() {
      var page = currentPage();
      var max = maxScroll();

      if (dotsWrap) {
        var dots = dotsWrap.children;
        for (var i = 0; i < dots.length; i++) {
          /* Distance drives the shrinking-dot window in CSS; anything 3 or
             further away is hidden so the indicator stays 5 dots wide. */
          dots[i].dataset.distance = String(Math.min(Math.abs(i - page), 3));
          dots[i].setAttribute('aria-current', i === page ? 'true' : 'false');
        }
      }

      if (prev) prev.disabled = viewport.scrollLeft <= 1;
      if (next) next.disabled = viewport.scrollLeft >= max - 1;
    }

    /* Move in whole cards so one never lands half-clipped at the edge. */
    function scrollByPage(direction) {
      var step = cardStep();
      var perView = Math.max(1, Math.floor(viewport.clientWidth / step));
      viewport.scrollBy({ left: direction * step * perView, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { scrollByPage(-1); });
    if (next) next.addEventListener('click', function () { scrollByPage(1); });

    if (dotsWrap) {
      dotsWrap.addEventListener('click', function (event) {
        var dot = event.target.closest('.frido-b2b-dot');
        if (!dot) return;
        var index = Number(dot.dataset.index);
        var target = pageCount < 2 ? 0 : (index / (pageCount - 1)) * maxScroll();
        viewport.scrollTo({ left: target, behavior: 'smooth' });
      });
    }

    var ticking = false;
    viewport.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        update();
        ticking = false;
      });
    }, { passive: true });

    if ('ResizeObserver' in window) {
      new ResizeObserver(measure).observe(viewport);
    } else {
      window.addEventListener('resize', measure);
    }

    /* Only play what's on screen — a row of autoplaying videos is expensive. */
    var videos = root.querySelectorAll('video[data-carousel-video]');
    if (videos.length && 'IntersectionObserver' in window) {
      var playObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            var attempt = video.play();
            if (attempt && attempt.catch) attempt.catch(function () {});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.25 });

      videos.forEach(function (video) { playObserver.observe(video); });
    }

    measure();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-b2b-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Theme editor re-renders sections in place. */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
